const e=async(e,t,n,r)=>{let{data:{secret:i}}=await e.get(`/webhooks/${t}/${n}/${r}/secret`);return i};export{e as getWebhookSecret};
//# sourceMappingURL=get-secret.mjs.map